import { render, staticRenderFns } from "./DeliveryDlg.vue?vue&type=template&id=65c325d1&scoped=true&"
import script from "./DeliveryDlg.vue?vue&type=script&lang=js&"
export * from "./DeliveryDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c325d1",
  null
  
)

export default component.exports